<div class="sidenav-content footer-margin" [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller"
	copoAfterViewInit (afterviewinit)="scroller.restoreState();">
	<div class="card-title-block-non-sticky">
		<div class="card-title-label" translate>ecall-off.call-off-follow-up</div>
	</div>
	<div class="copo-container">
		<copo-last-call-off-demand-widget></copo-last-call-off-demand-widget>
	</div>
</div>